import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserAccountService } from '../../../common/service/user-account.service';
import { standardCommand } from '../../../core/model/command';
import { CommandDispatcher } from '../../../core/service/command/command-dispatcher.service';
import { DeleteCommandHandler } from '../../../core/service/command/delete-command-handler.service';
import { ColumnDefinitionFactory } from '../../../core/service/factory/column-definition-factory.service';
import { MessageService } from '../../../core/service/message.service';
import { NavigationService } from '../../../core/service/navigation.service';
import { Invoice } from '../../model/invoice';
import { UnpaidInvoiceCommandHandlerResolver } from '../../service/command/unpaid-invoice-command-handler-resolver.service';
import { CreditInvoiceService } from '../../service/data/credit-invoice.service';
import { InvoiceService } from '../../service/data/invoice.service';
import { InvoiceListComponentBase } from '../base/invoice-list.base';

@Component({
    selector: 'app-tenant-invoices',
    templateUrl: './tenant-invoices.component.html',
    styleUrls: ['./tenant-invoices.component.scss'],
    providers: [DeleteCommandHandler, UnpaidInvoiceCommandHandlerResolver],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenantInvoicesComponent extends InvoiceListComponentBase implements OnInit {
  constructor(
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _creditInvoiceService: CreditInvoiceService,
    private readonly _invoiceService: InvoiceService,
    accountService: UserAccountService,
    dispatcher: CommandDispatcher,
    factory: ColumnDefinitionFactory,
    handlerResolver: UnpaidInvoiceCommandHandlerResolver,
    messageService: MessageService,
    navigationService: NavigationService
  ) {
    super(factory, accountService, _invoiceService, dispatcher, handlerResolver, messageService, navigationService);
  }

  creditInvoices: Invoice[];

  ngOnInit() {
    this.AddSubscription(
      this._activatedRoute.paramMap.subscribe(map => {
        let id = map.get('id');
        if (id) {
          this.AddSubscription(
            this._invoiceService.getTenantInvoices(id).subscribe(data => {
              this.itemsSource = data;
            })
          );
          this.AddSubscription(
            this._creditInvoiceService.getContactInvoices(id).subscribe(data => {
              this.creditInvoices = data;
            })
          );
        }
      })
    );

    this.addContextMenuItemDefinition('DELETE_BTN', standardCommand.delete);
  }

  onRowClicked(e: { context: any; event: any }) {
    this.navigation.navigate(['invoices', 'edit', e.context.id], e.event.ctrlKey);
  }
}
